module.exports = __webpack_public_path__ + "static/media/decibel-implementation.2ea1a6bb.md";